var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRefreshClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5216 5.98014H7.844L9.3302 4.45054C7.84942 2.98602 5.45196 2.93178 3.97117 4.3963C2.49039 5.86623 2.49039 8.23658 3.97117 9.70651C5.45196 11.1764 7.84942 11.1764 9.3302 9.70651C10.0679 8.97968 10.4367 8.12809 10.4367 7.05412H11.5216C11.5216 8.12809 11.0442 9.52209 10.0896 10.4659C8.18572 12.3535 5.09397 12.3535 3.1901 10.4659C1.29165 8.58372 1.27538 5.52451 3.17925 3.64234C5.08312 1.76017 8.1369 1.76017 10.0408 3.64234L11.5216 2.11816V5.98014ZM6.91105 4.83023V7.13548L8.80949 8.2637L8.41895 8.92001L6.09743 7.54229V4.83023H6.91105Z",
    fill: "#00322E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshClock);
export default __webpack_public_path__ + "static/media/refresh-clock.5d6402c9e7fb1b087726f12604b13092.svg";
export { ForwardRef as ReactComponent };